import { FC, ReactNode } from 'react';
import { Collapsible } from '@features/ui/components';
import { Divider } from '@features/ui';
import { TSectionCollapsible } from '@src/types';

interface KnowledgeBaseSectionProps {
  title: string;
  desc?: string;
  iconComponent?: ReactNode;
  data: TSectionCollapsible[];
}
export const KnowledgeBaseSection: FC<KnowledgeBaseSectionProps> = ({
  title,
  desc,
  iconComponent,
  data,
}) => {
  return (
    <div>
      <div className={'flex items-end gap-3 flex-wrap mb-1.5'}>
        <div className={'flex items-center gap-x-3'}>
          {iconComponent}
          <p className={'text-2xl pb-[0px]'}>{title}</p>
        </div>
        <p className={'text-xs mb-1'}>{desc}</p>
      </div>
      <Divider />
      {data.map((item) => (
        <div key={item.id}>
          <Collapsible item={item} />
          <Divider />
        </div>
      ))}
    </div>
  );
};
